import React from 'react';

import { CustomLessonViewHeaderContainer } from 'common.components/lesson-view.custom-view/__header/custom-lesson-view__header.container';

import { CustomLessonViewButton, BUTTON_TYPES } from './__button/custom-lesson-view__button';
import { CustomLessonViewLanding } from './__landing/custom-lesson-view__landing';
import { CustomLessonViewWrapper } from './__wrapper/custom-lesson-view__wrapper';

interface Props {
    landingSrc: string | null;
}

export const CustomLessonView = React.memo((props: Props) => {
    const { landingSrc } = props;

    return (
        <CustomLessonViewWrapper>
            <CustomLessonViewHeaderContainer
                controls={
                    <>
                        <CustomLessonViewButton type={BUTTON_TYPES.TEACHER_DISPLAY} />
                        <CustomLessonViewButton type={BUTTON_TYPES.TEACHER_VIEW_AS_STUDENT} />
                    </>
                }
            />
            <CustomLessonViewLanding src={landingSrc} />
        </CustomLessonViewWrapper>
    );
});
